module.exports = __webpack_public_path__ + "img/widget_v004.606523a3.png";